import { FaEnvelope, FaInstagram , FaLinkedin} from "react-icons/fa";

export default function Footer() {
  return (
    <footer id="footer" className="bg-background text-dark px-6 py-10 mt-20 border-t border-gray-300">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between gap-8">
        
        {/* About / Logo */}
        <div className="flex flex-col gap-2">
          <h2 className="text-2xl font-semibold">Inter<span className="text-accent">link</span></h2>
          <p className="text-sm max-w-xs">
            A cross-disciplinary hub for students to innovate, learn, and connect.
          </p>
        </div>

        {/* Quick Links */}
        <div className="flex flex-col gap-2">
          <h3 className="font-semibold">Quick Links</h3>
          <ul className="space-y-1">
            <li><a href="#home" className="hover:text-primary">Home</a></li>
            <li><a href="#about" className="hover:text-primary">About</a></li>
            <li><a href="#join" className="hover:text-primary">Join</a></li>
            <li><a href="#contact" className="hover:text-primary">Contact</a></li>
          </ul>
        </div>

        {/* Instagram Section */}
        <div className="flex flex-col gap-2">
          <h3 className="font-semibold">Contact</h3>
          <div className="flex flex-col align-baseline gap-2">
            <a className="flex align-baseline gap-1 hover:text-primary" href="https://www.instagram.com/interlink_club/" target="_blank" rel="noopener noreferrer">
              <FaInstagram size={30}/>
              <h3>Instgram</h3>
            </a>
            <a className="flex align-baseline gap-1 hover:text-primary" href="https://www.linkedin.com/company/interlink-club/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin size={30} />
              <h3>LinkedIn</h3>
            </a>
            <a className="flex align-baseline gap-1 hover:text-primary" href="mailto:farhatagraine@gmail.com" target="_blank" rel="noopener noreferrer">
              <FaEnvelope size={30}/>
              <h3>gmail</h3>
            </a>
          </div >
          {/* Optional: Embed single Instagram post */}
          
        </div>
      </div>

      {/* Bottom Text */}
      <div className="mt-10 text-center text-xs text-gray-500">
        &copy; {new Date().getFullYear()} Interlink Club | University of Biskra
      </div>
    </footer>
  );
}
